import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@/utils/constants'

// Import locale messages
import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'

const resources = {
  en: {
    translation: en
  },
  es: {
    translation: es
  },
  fr: {
    translation: fr
  }
}

// Get initial locale from localStorage or use default
const getInitialLocale = (): string => {
  const saved = localStorage.getItem('user-store')
  if (saved) {
    try {
      const userStore = JSON.parse(saved)
      if (userStore.state?.userPreferences?.language && SUPPORTED_LOCALES.includes(userStore.state.userPreferences.language as any)) {
        return userStore.state.userPreferences.language
      }
    } catch (error) {
      console.warn('Failed to load locale from localStorage:', error)
    }
  }
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0]
  if (SUPPORTED_LOCALES.includes(browserLang as any)) {
    return browserLang
  }
  
  return DEFAULT_LOCALE
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLocale(),
    fallbackLng: DEFAULT_LOCALE,
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n

// Helper function to change locale
export const setLocale = (locale: string) => {
  if (SUPPORTED_LOCALES.includes(locale as any)) {
    i18n.changeLanguage(locale)
    document.documentElement.lang = locale
  }
}


